<template>
  <div class="asc-unauthorized-container">
    <asc-unauthorized-wrapper></asc-unauthorized-wrapper>
  </div>
</template>

<script>
import AscUnauthorizedWrapper from '@/components/organisms/AscUnauthorizedWrapper'

export default {
  name: 'AscUnauthorizedContainer',

  components: {
    AscUnauthorizedWrapper,
  },
}
</script>

<style lang="scss">
.asc-unauthorized-container {
  background-color: $gray-100;

  & .container {
    padding: 16px 16px 0 16px;
  }
}
</style>
